import { useHealth } from '../api/hooks'
import { QueryState } from '../components/QueryState'
import { fmtDate } from '../lib/format'

/** Состояние ядра: видно, можно ли доверять данным прямо сейчас. */
export default function Health() {
  const q = useHealth()
  const h = q.data
  const stale = h && h.age_min > h.stale_after_min

  return (
    <>
      <div className="page-head">
        <h1>Состояние ядра</h1>
      </div>

      <QueryState isLoading={q.isLoading} error={q.error}>
        {h && (
          <div className="grid-2">
            <div>
              <div className="card">
                <h2>Синхронизация</h2>
                <dl className="dl">
                  <dt>Отставание синка</dt>
                  <dd className={stale ? 'error' : ''}>
                    {Math.round(h.age_min)} мин {stale ? `(порог ${h.stale_after_min} — данные считаются устаревшими)` : '— в норме'}
                  </dd>
                  <dt>Реалтайм-вебхуки</dt><dd>{h.realtime ? 'приходят' : 'не приходили'}</dd>
                  <dt>Shadow-сверка</dt><dd>{h.compare ? 'включена' : 'выключена'}</dd>
                  <dt>Расхождений за 24ч</dt>
                  <dd className={h.counts.diffs_24h > 0 ? 'error' : ''}>{h.counts.diffs_24h}</dd>
                </dl>
              </div>

              <div className="card">
                <h2>Водяные знаки по сущностям</h2>
                {/* `cards` — на телефоне таблица разбирается на карточки (styles.css, §12). */}
                <div className="table-wrap cards">
                  <table>
                    <thead>
                      <tr><th>Сущность</th><th className="nowrap">Последнее изменение</th><th className="nowrap">Обновлено</th></tr>
                    </thead>
                    <tbody>
                      {h.sync.map((s) => (
                        <tr key={s.entity}>
                          <td className="mono" data-label="Сущность">{s.entity}</td>
                          <td className="nowrap muted" data-label="Последнее изменение">{s.last_modify || '—'}</td>
                          <td className="nowrap muted" data-label="Обновлено">{fmtDate(s.updated_at, true)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="card">
              <h2>Объём данных</h2>
              <dl className="dl">
                <dt>Сделки</dt><dd>{h.counts.deals.toLocaleString('ru-RU')}</dd>
                <dt>Компании</dt><dd>{h.counts.companies.toLocaleString('ru-RU')}</dd>
                <dt>Контакты</dt><dd>{h.counts.contacts.toLocaleString('ru-RU')}</dd>
              </dl>
            </div>
          </div>
        )}
      </QueryState>
    </>
  )
}
